import React from 'react'
import { useInView } from 'react-intersection-observer'
import loadable from '@loadable/component'

const TextBlock = loadable(() => import('./blocks/TextBlock'))
const ImageBlock = loadable(() => import('./blocks/ImageBlock'))
const WidgetBlock = loadable(
  () => import('js/components/WidgetBlock/WidgetBlock'),
)
const AsideBlock = loadable(() => import('./blocks/AsideBlock'))
const CheckmarkListBlock = loadable(() => import('./blocks/CheckmarkListBlock'))
const PullQuoteBlock = loadable(() => import('./blocks/PullQuoteBlock'))

const blocks = {
  ArticleTextRecord: TextBlock,
  ArticleImageRecord: ImageBlock,
  WidgetRecord: WidgetBlock,
  AsideRecord: AsideBlock,
  CheckmarkListRecord: CheckmarkListBlock,
  PullQuoteRecord: PullQuoteBlock,
}

type Props = {
  type: keyof typeof blocks
}

export default function NutritionArticleBlock({ type, ...props }: Props) {
  const [inViewRef, inView] = useInView({ triggerOnce: true })
  const Block = blocks[type]

  if (!Block) {
    console.warn(`Skipping nutrition article block of unknown type: ${type}`)
    return null
  }

  return (
    <div ref={inViewRef}>
      <Block {...props} inView={inView} />
    </div>
  )
}
